export enum enumGACheckoutSteps {
  PaymentDelayed = 1,
  CreatePayment = 2,
  PaymentSuccess = 3,
  PaymentFailed = 4,
  PaymentCanceled = 5,
}
